const initialState = {
    frontImage: JSON.parse(localStorage.getItem('frontImage')) || null,
    backImage: JSON.parse(localStorage.getItem('backImage')) || null,
};

const healthVerifyIdReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_HEALTH_VERIFY_ID':
            const { frontImage, backImage } = action.payload;

            if (frontImage !== undefined) {
                localStorage.setItem('frontImage', JSON.stringify(frontImage));
            }
            if (backImage !== undefined) {
                localStorage.setItem('backImage', JSON.stringify(backImage));
            }

            return {
                ...state,
                frontImage: frontImage !== undefined ? frontImage : state.frontImage,
                backImage: backImage !== undefined ? backImage : state.backImage,
            };
        default:
            return state;
    }
};

export default healthVerifyIdReducer;